import React from "react";
import { FaRegThumbsUp } from "react-icons/fa";
import { FaCarAlt } from "react-icons/fa";
import { FaRegBuilding } from "react-icons/fa";
import { FaClockRotateLeft } from "react-icons/fa6";

const Facts = () => {
  return (
    <div className="container-fluid counter bg-secondary py-5">
      <div className="container py-5">
        <div className="row g-5">
          <div
            className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="counter-item text-center">
              <div className="counter-item-icon mx-auto">
                <FaRegThumbsUp size={24} />
              </div>
              <div className="counter-counting my-3">
                <span
                  className="text-white fs-2 fw-bold"
                  data-toggle="counter-up"
                >
                  1,200
                </span>
                <span className="h1 fw-bold text-white">+</span>
              </div>
              <h4 className="text-white mb-0">Happy Clients</h4>
            </div>
          </div>
          <div
            className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="counter-item text-center">
              <div className="counter-item-icon mx-auto">
                <FaCarAlt size={24} />
              </div>
              <div className="counter-counting my-3">
                <span
                  className="text-white fs-2 fw-bold"
                  data-toggle="counter-up"
                >
                  80
                </span>
                <span className="h1 fw-bold text-white">+</span>
              </div>
              <h4 className="text-white mb-0">Fleet of Cars</h4>
            </div>
          </div>
          <div
            className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="counter-item text-center">
              <div className="counter-item-icon mx-auto">
                <FaRegBuilding size={24} />
              </div>
              <div className="counter-counting my-3">
                <span
                  className="text-white fs-2 fw-bold"
                  data-toggle="counter-up"
                >
                  15
                </span>
                <span className="h1 fw-bold text-white">+</span>
              </div>
              <h4 className="text-white mb-0">Rental Locations</h4>
            </div>
          </div>
          <div
            className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp"
            data-wow-delay="0.7s"
          >
            <div className="counter-item text-center">
              <div className="counter-item-icon mx-auto">
                <FaClockRotateLeft size={24} />
              </div>
              <div className="counter-counting my-3">
                <span
                  className="text-white fs-2 fw-bold"
                  data-toggle="counter-up"
                >
                  1,000,000
                </span>
                <span className="h1 fw-bold text-white">+</span>
              </div>
              <h4 className="text-white mb-0">Total Kilometers Driven</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Facts;
